import { Plugin } from "chart.js";

import newTheme from "@/new_theme";
import { getCSSVar } from "@/utils";

const DoughnutCenterTextPlugin: Plugin<
  "doughnut",
  DoughnutCenterTextPluginOptions
> = {
  id: "doughnutCenterText",
  beforeDatasetsDraw(chart, _, pluginOptions) {
    const { ctx } = chart;
    // This is annoying, but the typings are wrong here.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { x, y, innerRadius } = chart.getDatasetMeta(0).data[0];
    const pieSize = innerRadius * 2;

    const scope = document.body.classList.contains("dark") ? "dark" : "default";

    ctx.save();
    ctx.fillStyle = getCSSVar("--chart-text-color", scope);
    ctx.textAlign = "center";
    ctx.textBaseline = "top";

    // Find the total height of the texts so that we can offset the text block and center it.
    const totalSize = pluginOptions.texts.reduce(
      (aggr, [, size]) => aggr + size * pieSize,
      0
    );

    // Draw each text
    pluginOptions.texts.reduce(
      (yOffset, [text, size]) => {
        const realSize = pieSize * size;
        ctx.font = `${realSize}px ${newTheme.fonts.body}`;
        ctx.fillText(text, x, yOffset);
        return yOffset + realSize;
      },
      y - totalSize / 2
    );

    ctx.restore();
  },
  defaults: {
    texts: [],
  },
};
export default DoughnutCenterTextPlugin;

export type DoughnutCenterTextPluginOptions = {
  texts: [string, number][];
};
